import { connect } from 'react-redux';
import * as R from 'ramda';
import AuthorizationSequencing from './AuthorizationSequencingOld';
import {
  getCurrentSelection,
  getStoreValueByProp,
  setFiltersOpen,
} from './store/authorizationSequencingSlice';
import { resetFilters, setFilters } from '../filters/store/filtersSlice';
import { getStoreValueByProp as getWizardStoreValueByProp } from './sequencing-wizard/store/sequencingWizardSlice';

const mapState = R.applySpec({
  currentSelection: getCurrentSelection,
  filters: R.o(
    R.pick(['nameShort', 'relatedIds', 'searchTerm', 'state']),
    R.path(['loadingManagement', 'filters'])
  ),
  filtersOpen: getStoreValueByProp(['filtersOpen']),
  locationsLoading: getWizardStoreValueByProp(['locationsLoading']),
  productsLoading: getWizardStoreValueByProp(['productsLoading']),
});

const mapDispatch = {
  resetFilters,
  setFilters,
  setFiltersOpen,
};

export default connect(mapState, mapDispatch)(AuthorizationSequencing);
